exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-learn-sanity-article-slug-current-jsx": () => import("./../../../src/pages/learn/{SanityArticle.slug__current}.jsx" /* webpackChunkName: "component---src-pages-learn-sanity-article-slug-current-jsx" */),
  "component---src-pages-sanity-page-slug-current-jsx": () => import("./../../../src/pages/{SanityPage.slug__current}.jsx" /* webpackChunkName: "component---src-pages-sanity-page-slug-current-jsx" */)
}

